import { gql } from '@apollo/client';

const query = gql`
  mutation CreateEnquiry($input: CreateEnquiryInput!) {
    createEnquiry(input: $input) {
      enquiry {
        id
      }
    }
  }
`;

module.exports = query;
